import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { multiClientMenuFilters } from '../mtEnterprises';

const routes = {
  name: 'Business Intelligence',
  nameES: 'Inteligencia Empresarial',
  icon: 'mdi-chart-box-outline',
  path: '/reports/businessIntelligence/',
  ...addPermissionsToRoute(['bu_quicksight_access']),
  menuFilters: multiClientMenuFilters,
  children: [
    {
      path: '/reports/businessIntelligence/tableau',
      name: 'Tableau Dashboard',
      nameES: 'Panel de Tableau',
      meta: { id: 'reports-mtTableauDashboard', hidePageHeader: true },
      component: () => import('./TableauDashboard.vue'),
    },
  ],
};

export default routes;
